<template>
    <div>
        <v-dialog v-model="show" hide-overlay persistent max-width="80%">
            <v-card>
                <v-card-title>
                    Media
                </v-card-title>
                <v-card-text>

                    <v-row>
                        <v-col cols="12" sm="5">
                            <div>
                                <v-text-field v-model="mediaId" type="number" label="Media Id"
                                              :error-messages="idError"></v-text-field>
                                <v-text-field v-model="mediaTitle" label="Media Title"
                                              :error-messages="titleError"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-btn style="text-align: center; top: 20%;" v-on:click="exportToLeft()">
                                <v-icon>mdi-ray-end-arrow</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <div>
                                <v-text-field v-model="search" label="Search AniList Media"
                                              v-on:keypress.enter="searchMedia()"></v-text-field>

                                <v-data-table
                                        :loading="isSearchingMedia"
                                        :headers="headers"
                                        :items="items"
                                        v-model="selected"
                                        show-select
                                        :single-select="true"
                                        hide-default-footer>
                                </v-data-table>
                                <pagination :page="page" :total-page="totalPage"
                                            @paginate="paginate($event)"></pagination>
                            </div>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>
    import Pagination from "../Pagination";
    import {CommonService, MediaDialogService} from "../../services";
    import {mapActions} from 'vuex';

    export default {
        name: "NewMediaDialog",
        components: {Pagination},
        props: ['show'],
        data() {
            return {
                isSearchingMedia: false,
                mediaId: '',
                mediaTitle: '',
                search: '',
                selected: [],
                headers: [
                    {text: 'Media Id', align: 'start', sortable: true, value: 'id',},
                    {text: 'Title', sortable: true, value: 'title',},
                    {text: 'Format', sortable: true, value: 'format',},
                ],
                items: [],
                page: 1,
                perPage: 5,
                totalPage: 0,
                idError: '',
                titleError: ''
            }
        },
        computed: {},
        methods: {
            ...mapActions({
                setSave: 'media/setSave'
            }),
            searchMedia() {
                if (this.search.trim() === '') return;
                this.items = [];
                this.isSearchingMedia = true;
                MediaDialogService.searchMedia({page: this.page, perPage: this.perPage}, this.search).then(items => {
                    this.totalPage = items.lastPage;
                    this.items = items.results;
                }).finally(() => {
                    this.isSearchingMedia = false
                });
            },
            exportToLeft() {
                if (!this.selected.length) return;

                this.mediaId = this.selected[0].id;
                this.mediaTitle = this.selected[0].title;

            },
            paginate(page) {
                this.page = page;
                this.searchMedia()
            },
            showLoading(b) {
                CommonService.showLoading(b);
            },
            close() {
                this.mediaId = '';
                this.mediaTitle = '';
                this.search = '';
                this.items = [];
                this.$emit('close');
            },
            save() {
                if (this.mediaTitle == null || this.mediaTitle.trim().length === 0) {
                    this.titleError = "Title is empty";
                    return;
                }

                if (this.mediaId == null || this.mediaId.length === 0) {
                    this.idError = "Id is empty";
                    return;
                }
                this.setSave({mediaId: this.mediaId, title: this.mediaTitle}).then(()=>{
                    this.mediaTitle = '';
                    this.mediaId = '';
                });
            }
        }
    }
</script>

<style scoped>

</style>